import styled from 'styled-components';

import { SharedInputStyles } from '~/components/input/Input.styles';
import { breakpoints } from '~/design-tokens/breakpoints/breakpoints';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const SearchInputRoot = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 223px;
  @media ${breakpoints['max-sm']} {
    width: 110px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  padding-left: 12px;
  gap: 8px;
  align-items: center;
  flex: 1 0 0;
  border: 1px solid var(--border-soft);
  border-radius: 40px;
  height: 40px;
  overflow: hidden;
`;

export const Input = styled.input`
  ${SharedInputStyles};
  ${typographyV2.bodyBase};
  width: 100%;
  color: inherit;
  cursor: pointer;
  padding: 0 20px 0 0;

  &::placeholder {
    ${typographyV2.bodySm};
  }
`;

export const SearchIcon = styled.div`
  display: flex;
  align-items: center;

  svg {
    fill: var(--icon-soft);
  }
`;
